module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/82e23f6faa635050405c91b4714d63c7.svg";